import axios from "axios";
import * as localforage from "localforage";
import { url } from "./apiSetup";
import { errorHandling } from "../helpers/errorHandling";
import requestRetry from "./requestRetry";

export const phpRequest = requestRetry(
  axios.create({
    // baseURL: `${url}/api/v2`,
    timeout: 1000 * 60
  })
);

let timer;
const origHttpGet = phpRequest.get;
const origHttpDelete = phpRequest.delete;

// 重写get方法，保持跟post方法传参一致
phpRequest.get = (url, params, config) => {
  return origHttpGet(url, { params, ...config });
};

// 重写delete方法，保持跟post方法传参一致
phpRequest.delete = (url, params, config) => {
  return origHttpDelete(url, { params, ...config });
};

phpRequest.blob = (url, params, config) => {
  return origHttpGet(url, { params, responseType: "blob", ...config });
};

phpRequest.interceptors.request.use(
  async config => {
    const token = await localforage.getItem("token");
    const company_id = await localforage.getItem("currentCompanyId");
    const lang = localStorage.getItem("rcml-lang");
    config.baseURL = `${url}/api/v2`;
    config.headers.Accept = "application/json";
    config.headers.Authorization = "Bearer " + (config.headers.token || token);
    config.headers.AcceptLanguage = lang || "en";

    if (config.method === "get" || config.method === "delete") {
      if (!config.params) {
        config.params = {};
      }
      if (!config.params.company_id) {
        config.params.company_id = company_id;
      }
    } else {
      if (!config.data) {
        config.data = {};
      }
      if (typeof config.data === "object") {
        if (config.data instanceof FormData) {
          if (!config.data.get("company_id")) {
            config.data.append("company_id", company_id);
          }
        } else if (!config.data.company_id) {
          config.data.company_id = company_id;
        }
      }
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

phpRequest.interceptors.response.use(
  response => {
    return response.data;
  },
  err => {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    // console.log("-----err---", err);
    // const { data } = err.response;
    // if (data.message) {
    //   const error = new Error(data.message || "unknown error");
    //   error.code = data.code ? data.code : 0;
    //   error.response = err.response;
    //   toast.error(data.message);
    //   return Promise.reject(error);
    // }
    timer = setTimeout(() => {
      if (err.name === "CanceledError") {
        return;
      }
      errorHandling(err);
    });

    return Promise.reject(err);
  }
);
